import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector, makeSectionIdsSelector } from "./selectors";
import { type CourseProgress } from "./types";

export enum Actions {
  InitBegin = "MEMBER_COURSE_PROGRESS_INIT_BEGIN",
  InitFailure = "MEMBER_COURSE_PROGRESS_INIT_FAILURE",
  InitSuccess = "MEMBER_COURSE_PROGRESS_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef & {
  courseId: string;
};
export type InitSuccessActionData = CourseProgress.Api.InitResponse;
const _init = initAction<BaseAppState, InitBeginActionData, CourseProgress.Api.InitResponse, InitSuccessActionData>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: BaseAppState, dispatch: any, params: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, params);
    const sectionsSelector = makeSectionIdsSelector();
    const sectionIds = sectionsSelector(state, { source: params.source });
    return api.init(apiInfo, params.courseId, !sectionIds.length ? [] : sectionIds.split(","));
  }
});

export const init = (args: EntityRef) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    if (state.portal.programId) {
      dispatch(_init({ ...args, courseId: state.portal.programId }));
    } else {
      dispatch({
        type: Actions.InitSuccess,
        data: {
          id: args.id,
          completed: 0,
          total: 0
        }
      });
    }
  }
};

export const reload = (args: EntityRef) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();

  const localState = localStateSelector(state, args);
  if (localState.status === Status.Ready) {
    dispatch(_init({ ...args, courseId: state.portal.programId! }));
  }
};
